<template>
  <div class="instructions">
    חשוב להקפיד ולהזין את
    <span class="bold">פרטי ההתחברות הקבועים שלך</span>.
    אם אין לך כאלו, אפשר ליצור אותם <span class="link" @click="openLink()">כאן</span>.
  </div>
</template>

<script>

import Segment from '../../../../Segment';

export default {
  name: 'IsracardInstructions',
  methods: {
    openLink() {
      Segment.trackUserInteraction('CardInstructionsClicked', {
        source: 'isracard',
      });
      window.open('https://digital.isracard.co.il/personalarea/loginarea/#/Register', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .bold {
    font-weight: bold;
  }
  .link {
    text-decoration: underline;
    color: $riseup_light_blue;
    cursor: pointer;
    font-weight: bold;
  }
</style>
